/* eslint-disable consistent-return */

import { removeFromEquipment } from '../../actions/game/equipment.actions'
import getEquipment from '../../selectors/getEquipment'
import itemHelper from '../../../utils/itemHelper'
import { groupBy } from '../../../utils/helper'

const { getItemData } = itemHelper

const equipmentMiddleware = ({ dispatch, getState }) => next => (action) => {
    const { payload, meta } = action
    const { checkEquipment } = meta || {}

    if (!checkEquipment) {
        return next(action)
    }

    /*
        const checkTargetForRequirements = (item, unitID) => true
        const checkTargetForConflictingEquipment = (
            itemFromInventory,
            unitFromRoster,
            usedSlots,
        ) => false
     */

    switch (checkEquipment) {
        case 'add': {
            const { items, unitID } = payload
            const currentEquipment = getEquipment(getState())
            const equipedItems = currentEquipment.map(item => (getItemData(item)))
            const usedSlots = groupBy(equipedItems, 'slot')

            const itemsToRemove = []
            const filteredItems = items.map((itemID) => {
                const itemFromInventory = getItemData(getState().inventory.filter(
                    invItem => invItem.ID === itemID
                )[0])
                const { slot } = itemFromInventory
                if (usedSlots[slot]) {
                    itemsToRemove.push(usedSlots[slot])
                }

                return { itemID, slot }
            })

            if (itemsToRemove.length) {
                const IDsToRemove = itemsToRemove.map(
                    things => things.map(thing => thing.ID)
                )
                dispatch(removeFromEquipment(IDsToRemove[0]))
            }

            if (filteredItems.length) {
                const newAction = Object.assign(
                    action, { payload: { items: filteredItems, unitID } }
                )
                next(newAction)
            }
            break
        }

        default: {
            next(action)
        }
    }
}

export default equipmentMiddleware
